// ─── App catalog types (mirrors AppSummary from backend task 85) ──────

export interface AppResources {
  vcpu: number;
  mem_mib: number;
}

export interface AppSummary {
  name: string;
  display_name: string;
  category: string;
  icon: string;
  resources: AppResources;
}

// ─── Type guards ──────────────────────────────────────────────────────

function isAppResources(v: unknown): v is AppResources {
  if (typeof v !== "object" || v === null) return false;
  const o = v as Record<string, unknown>;
  return typeof o["vcpu"] === "number" && typeof o["mem_mib"] === "number";
}

export function isAppSummary(v: unknown): v is AppSummary {
  if (typeof v !== "object" || v === null) return false;
  const o = v as Record<string, unknown>;
  return (
    typeof o["name"] === "string" &&
    typeof o["display_name"] === "string" &&
    typeof o["category"] === "string" &&
    typeof o["icon"] === "string" &&
    isAppResources(o["resources"])
  );
}

export function isAppSummaryList(v: unknown): v is AppSummary[] {
  return Array.isArray(v) && v.every(isAppSummary);
}
